export default "__VITE_ASSET__B3I9_OER__";